//We can't use the existing "ConfigurationToName", because the BE types are a bit different for "issues"
export const resourceTypeToLabel: {
  [key: string]: string;
} = {
  ValidationRule: 'Validation Rule',
  ApprovalProcess: 'Approval Process',
  WorkflowRule: 'Workflow Rule',
  Flow: 'Flow',
  Layout: 'Layout',
  ApexTrigger: 'Apex Trigger',
  ApexClass: 'Apex Class',
  LightningComponentBundle: 'Lightning Component Bundle',
};
